const useParseString = () => {
  function formatCurrency(number) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(number);
  }

  function formatUserType(userType) {
    const userTypeTranslations = {
      COORDINATOR: "Coordinador",
      GUIDE: "Guía",
      SELLER: "Vendedor",
      USER_COORDINATOR: "Coordinador",
      USER_GUIDE: "Guía",
      USER_SELLER: "Vendedor",
      COMPANY: "Empresa",
      GROUP: "Grupo",
      OFFICE_WORKER: "Oficina",
    };

    return userTypeTranslations[userType];
  }

  function formatExpenseType(expenseType) {
    const expenseTypeTranslations = {
      GUIDE_PAYMENT: "Paga Guiada",
      TRANSPORT_PAYMENT: "Paga Transportista",
      FIXED_COST_PER_PASSENGER: "Gasto Fijo de la Excursión por Pasajero",
      ADDITIONAL_EXPENSES: "Gastos Adicionales",
      SELLER_TAXI: "Gasto de Taxi de Vendedor",
    };

    return expenseTypeTranslations[expenseType];
  }

  return { formatCurrency, formatUserType, formatExpenseType };
};

export default useParseString;
